module.exports = __webpack_public_path__ + "images/for_company_page/plan-pr-sp_14eabf7d7f8145f22c5c4e4379270a1e.png";